import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from './salesData';
interface TestimonialCardProps {
  t: Testimonial;
}
export function TestimonialCard({
  t
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-rose/10 bg-white p-6 shadow-sm" data-id="element-241" data-mp="2kfx2pt6dsgi3">
      <div className="flex items-center gap-3" data-id="element-242" data-mp="2p8hwiupaetlm">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blush font-display text-sm font-bold text-rose-deep" data-id="element-243" data-mp="2u6rsh7iu5y8a">
          {t.initials}
        </span>
        <div data-id="element-244" data-mp="2z7ywqwlrsfa7">
          <figcaption className="text-sm font-bold text-ink" data-id="element-245" data-mp="344z4rd26js3y">{t.name}</figcaption>
          <p className="text-xs text-ink/55" data-id="element-246" data-mp="342uqc16nnapf">
            📍 {t.location} · {t.role}
          </p>
        </div>
      </div>
      <div className="mt-3 flex text-rose" aria-label="5 de 5 estrellas" data-id="element-247" data-mp="19r7nbrdm03xy">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-248" data-mp="1ds00uwtikv01" data-mpi={i} />)}
      </div>
      <blockquote className="mt-3 text-sm leading-relaxed text-ink/75" data-id="element-249" data-mp="hskqyrwa7k55">"{t.quote}"</blockquote>
    </figure>;
}